import _ from 'lodash';
import React from 'react';

import {imageUrl} from '../../../utilities/requests';
import * as styles from '../../../styles';


export default class PrintStudentReport extends React.PureComponent {
    render() {
        const subjects = _.mapKeys(this.props.examination.subjects, item => item.id);
        const rootSubjects = _.uniq(_.union(..._.map(
            this.props.examination.questions,
            item => _.map(item.subjects, item => item.root_subject),
        )));
        const levels = _.filter(
            _.uniqBy(_.map(this.props.examination.questions, item => item.level), 'id'),
            item => item,
        );
        const types = _.filter(
            _.uniqBy(_.map(this.props.examination.questions, item => item.question_type), 'id'),
            item => item,
        );
        const questions = _.mapKeys(this.props.examination.questions, item => item.id);
        const clazz = (_.find(this.props.data, data => (
            data.field === 31 &&
            data.student === this.props.student.id &&
            data.category_is_global &&
            data.group_class
        )) || {'group_class': null}).group_class;
        const Td = props => <td {...props} style={{...styles.softTd, ...(props.style || {})}}>{props.children}</td>;
        const Mtd = props => <td {...props} style={{...styles.softTd, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </td>;
        const Th = props => <th {...props} style={{...styles.softTh, ...(props.style || {})}}>{props.children}</th>;
        const Mth = props => <th {...props} style={{...styles.softTh, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </th>;
        return <div
            style={{
                position: 'relative',
                width: '297mm',
                height: '209mm',
                pageBreakAfter: this.props.last ? undefined : 'always',
            }}>
            <div
                style={{
                    position: 'absolute',
                    top: '19mm',
                    right: '60mm',
                    width: '52mm',
                    fontSize: '1.65em',
                }}>
                <div style={{textAlign: 'center'}}>
                    <b>{window.gettext('Student Report')}</b>
                </div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: '6mm',
                    right: '126mm',
                    width: '67mm',
                    fontSize: '.9em',
                }}>
                <div style={{overflow: 'hidden', height: '2.3em'}}>
                    <b>{window.gettext('Name')}:</b>
                    &nbsp;
                    {this.props.student.firstname} - {this.props.student.lastname}
                </div>
                <div style={{overflow: 'hidden', height: '2.3em'}}>
                    <b>{window.gettext('School Name')}:</b> {this.props.school.name.persian()}
                </div>
                <div style={{overflow: 'hidden', height: '2.3em', fontSize: '.9em'}}>
                    <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                    {this.props.examination.title.persian()} - {this.props.examination.grades[0].title.persian()}
                </div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: '5mm',
                    right: '202mm',
                    width: '37mm',
                    fontSize: '.9em',
                }}>
                <div style={{overflow: 'hidden', height: '2.3em'}}>
                    <b>{window.gettext('National ID')}:</b> {(this.props.student.national_id || '').persian()}
                </div>
                <div style={{overflow: 'hidden', height: '2.3em'}}>
                    <b>{window.gettext('City')}:</b> {(this.props.school.city.name || '').persian()}
                </div>
                <div style={{overflow: 'hidden', height: '2.2em'}}>
                    <b>{window.gettext('Class')}:</b>
                    &nbsp;
                    {_.find(this.props.school.classes, item => item.id === clazz).name.persian()}
                </div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    bottom: '5mm',
                    right: '17mm',
                    width: '80mm',
                }}>
                <div style={{overflow: 'hidden', height: '2.3em'}}>
                    <b>{window.gettext('Analyze Date')}:</b>
                    &nbsp;
                    {(this.props.examination.analyze_date || '').toJalali().persian()}
                </div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    bottom: '7mm',
                    right: '118mm',
                    fontSize: '1.3em',
                    fontFamily: 'Arial',
                }}>
                <b>www.mhelli.ir</b>
            </div>
            <img
                style={{
                    position: 'absolute',
                    top: '5mm',
                    right: '33mm',
                    width: '26mm',
                }}
                src={imageUrl(window.images.logo, {
                    height: 140,
                    type: 'contain',
                })}
                onLoad={this.props.imageLoaded}
                onError={this.props.imageLoaded}
            />
            <div
                style={{
                    position: 'absolute',
                    top: '29mm',
                    left: '12mm',
                    right: '7mm',
                }}>
                <div
                    style={{
                        justifyContent: 'space-around',
                        width: '100%',
                    }}>
                    <div
                        style={{
                            flexGrow: '1',
                            textAlign: 'center',
                            padding: '1em',
                            float: 'right',
                            width: '60%',
                            boxSizing: 'border-box',
                        }}>
                        <div style={{height: '1.68em', width: '100%'}}></div>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                fontSize: '1.1em',
                                width: '100%',
                                border: '.0625em solid #eaeaea',
                            }}>
                            <thead>
                                <tr>
                                    <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Total Score')}</Mth>
                                    <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Score')}</Mth>
                                    <Th rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Status')}</Th>
                                    <Mth
                                        colSpan='3'
                                        style={{
                                            borderLeft: '.0625em solid #cacaca',
                                            borderRight: '.0625em solid #cacaca',
                                            lineHeight: undefined,
                                        }}>
                                        {window.gettext('Average')}
                                    </Mth>
                                    <Mth
                                        colSpan='3'
                                        style={{
                                            borderLeft: '.0625em solid #cacaca',
                                            borderRight: '.0625em solid #cacaca',
                                            lineHeight: undefined,
                                        }}>
                                        {window.gettext('Rank')}
                                    </Mth>
                                    <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Top 4th')}</Mth>
                                </tr>
                                <tr>
                                    <Mth style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Class')}</Mth>
                                    <Mth style={{lineHeight: undefined}}>{window.gettext('School')}</Mth>
                                    <Mth style={{borderLeft: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Global')}</Mth>
                                    <Mth style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Class')}</Mth>
                                    <Mth style={{lineHeight: undefined}}>{window.gettext('School')}</Mth>
                                    <Mth style={{borderLeft: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Global')}</Mth>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <Mtd>
                                        {_.sumBy(
                                            this.props.examination.questions,
                                            item => _.sumBy(item.scores, 'score'),
                                        ).toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd>{_.sumBy(this.props.results, 'mark').persian()}</Mtd>
                                    <Td>
                                        {_.sumBy(this.props.results, 'mark').scoreStatus(_.sumBy(
                                            this.props.examination.questions,
                                            item => _.sumBy(item.scores, 'score'),
                                        ))}
                                    </Td>
                                    <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.field === 21 &&
                                            data.clazz === clazz
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.field === 21 &&
                                            data.school
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd style={{borderLeft: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.field === 21 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.student === this.props.student.id &&
                                            data.field === 31 &&
                                            data.group_class
                                        )) || {value: 0}).value.toFixed().persian()}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.student === this.props.student.id &&
                                            data.field === 31 &&
                                            data.group_school
                                        )) || {value: 0}).value.toFixed().persian()}
                                    </Mtd>
                                    <Mtd style={{borderLeft: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.student === this.props.student.id &&
                                            data.field === 31 &&
                                            data.group_is_global
                                        )) || {value: 0}).value.toFixed().persian()}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.category_is_global &&
                                            data.field === 23 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                </tr>
                            </tbody>
                        </table>
                        <span>
                            {window.gettext('Examining the status of the student in subjects of the examinaiton')}
                        </span>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                border: '.0625em solid #eaeaea',
                            }}>
                            <thead>
                                <tr>
                                    <Th>{window.gettext('Index')}</Th>
                                    <Th>{window.gettext('Subject')}</Th>
                                    <Mth>{window.gettext('Count')}</Mth>
                                    <Mth>{window.gettext('Total Score')}</Mth>
                                    <Mth>{window.gettext('Score')}</Mth>
                                    <Mth>{window.gettext('Status')}</Mth>
                                    <Mth>{window.gettext('Average')}</Mth>
                                    <Mth>{window.gettext('Top 4th')}</Mth>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    _.sortBy(rootSubjects),
                                    (subject, index) => <tr key={subject}>
                                        <Td>{(index + 1).persian()}</Td>
                                        <Td>{subjects[subject].title}</Td>
                                        <Mtd>
                                            {_.size(_.filter(
                                                this.props.examination.questions,
                                                item => _.some(item.subjects, item => item.root_subject === subject),
                                            )).persian()}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.props.examination.questions,
                                                    item => _.some(item.subjects, item => item.root_subject === subject),
                                                ),
                                                item => _.sumBy(item.scores, 'score'),
                                            ).toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.props.results,
                                                    item => _.some(
                                                        questions[item.question].subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                'mark',
                                            ).toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.props.results,
                                                    item => _.some(
                                                        questions[item.question].subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                'mark',
                                            ).scoreStatus(_.sumBy(
                                                _.filter(
                                                    this.props.examination.questions,
                                                    item => _.some(
                                                        item.subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                item => _.sumBy(item.scores, 'score'),
                                            ))}
                                        </Mtd>
                                        <Mtd>
                                            {(_.find(this.props.data, data => (
                                                data.subject === subject &&
                                                data.field === 21 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {(_.find(this.props.data, data => (
                                                data.subject === subject &&
                                                data.field === 23 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                    </tr>,
                                )}
                            </tbody>
                        </table>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                width: '100%',
                            }}>
                            <div style={{flexGrow: '1', textAlign: 'center', paddingLeft: '1em', paddingTop: '2em'}}>
                                <span>
                                    {window.gettext('Examining the status of the student in different levels of questions')}
                                </span>
                                <table
                                    style={{
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        border: '.0625em solid #eaeaea',
                                    }}>
                                    <thead>
                                        <tr>
                                            <Th>{window.gettext('Index')}</Th>
                                            <Th>{window.gettext('Level')}</Th>
                                            <Mth>{window.gettext('Count')}</Mth>
                                            <Mth>{window.gettext('Total Score')}</Mth>
                                            <Mth>{window.gettext('Score')}</Mth>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            _.sortBy(levels, 'id'),
                                            (level, index) => <tr key={level.id}>
                                                <Td>{(index + 1).persian()}</Td>
                                                <Td>{level.title}</Td>
                                                <Mtd>
                                                    {_.size(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.level && item.level.id === level.id,
                                                    )).persian()}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.level && item.level.id === level.id,
                                                    ), item => _.sumBy(item.scores, 'score')).toFixed(2).persian(true)}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.results,
                                                        item => questions[item.question].level &&
                                                        questions[item.question].level.id === level.id,
                                                    ), 'mark').toFixed(2).persian(true)}
                                                </Mtd>
                                            </tr>,
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{flexGrow: '1', textAlign: 'center', paddingRight: '1em', paddingTop: '2em'}}>
                                <span>
                                    {window.gettext('Examining the status of the student in different types of questions')}
                                </span>
                                <table
                                    style={{
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        border: '.0625em solid #eaeaea',
                                    }}>
                                    <thead>
                                        <tr>
                                            <Th>{window.gettext('Index')}</Th>
                                            <Th>{window.gettext('Type')}</Th>
                                            <Mth>{window.gettext('Count')}</Mth>
                                            <Mth>{window.gettext('Total Score')}</Mth>
                                            <Mth>{window.gettext('Score')}</Mth>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            _.sortBy(types, 'id'),
                                            (type, index) => <tr key={type.id}>
                                                <Td>{(index + 1).persian()}</Td>
                                                <Td>{type.title}</Td>
                                                <Mtd>
                                                    {_.size(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.question_type &&
                                                        item.question_type.id === type.id,
                                                    )).persian()}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.question_type &&
                                                        item.question_type.id === type.id,
                                                    ), item => _.sumBy(item.scores, 'score')).toFixed(2).persian(true)}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.results,
                                                        item => questions[item.question].question_type &&
                                                        questions[item.question].question_type.id === type.id,
                                                    ), 'mark').toFixed(2).persian(true)}
                                                </Mtd>
                                            </tr>,
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            flexGrow: '1',
                            textAlign: 'center',
                            padding: '1em',
                            float: 'right',
                            width: '40%',
                            boxSizing: 'border-box',
                        }}>
                        <span>
                            {window.gettext('Examining the operation of the student each question')}
                        </span>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                border: '.0625em solid #eaeaea',
                                fontSize: this.props.results.length > 20
                                ? 20 / this.props.results.length + 'em'
                                : undefined,
                            }}>
                            <thead>
                                <tr>
                                    <Th>{window.gettext('Question')}</Th>
                                    <Th>{window.gettext('Subject')}</Th>
                                    <Mth>{window.gettext('Total Score')}</Mth>
                                    <Mth>{window.gettext('Score')}</Mth>
                                    <Mth>{window.gettext('Average')}</Mth>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    _.sortBy(this.props.results, item => questions[item.question].index),
                                    ({question, mark}) => <tr key={question}>
                                        <Td>{(questions[question].index + 1).persian()}</Td>
                                        <Td style={{maxWidth: '6.4cm', textOverflow: 'ellipsis', overflow: 'hidden'}}>
                                            {_.map(
                                                _.uniq(_.union(..._.map(
                                                    questions[question].subjects,
                                                    item => _.reverse(_.slice(item.subjects)),
                                                ))),
                                                (item, index) => index === 0 && subjects[item].title.length > 16
                                                ? subjects[item].title.substr(0, 16) + '…'
                                                : subjects[item].title,
                                            ).join(' - ')}
                                        </Td>
                                        <Mtd>
                                            {_.sumBy(questions[question].scores, 'score').toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>{mark.toFixed(2).persian(true)}</Mtd>
                                        <Mtd>
                                            {(_.find(this.props.data, data => (
                                                data.question === question &&
                                                data.field === 21 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                    </tr>,
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>;
    }
};
